module.exports = "# Easily Compress Images Online\r\n\r\nAdvanced PNG and JPEG compressor for reducing file size without quality loss\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/containers/CompressImages/compress-images-header.md
// module id = 1139
// module chunks = 0